module.exports = __webpack_public_path__ + "static/logo-sq-830b6fbaa8b996920326b2aec82ce4bc.png";